<!-- No case types message -->
<div
  class="flex-row align-items-center justify-content-center"
  style="margin: 0 auto; padding: 48px"
  *ngIf="noCaseTypes && !loading"
>
  {{ 'info.no_case_types' | translate }}
</div>

<!-- Table content wrapper with loading overlay -->
<div
  class="table-wrapper"
  [class.loading]="loading"
  [style.min-height.px]="containerHeight"
  *ngIf="!noCaseTypes"
>
  <!-- Loading overlay - preserves the space while showing loading state -->
  <div class="loading-overlay" *ngIf="loading">
    <div class="loading-content">
      <i class="ri-loader-4-line spin"></i>
      {{ 'info.loading_data' | translate }}
    </div>
  </div>

  <!-- Table content - visible but dimmed during loading -->
  <table mat-table [dataSource]="items" class="spotlab-table" matSort [class.dimmed]="loading">
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'core.name' | translate | uppercase }}
    </th>
    <td mat-cell *matCellDef="let caseType" class="name-cell">
      {{ caseType.name }}
    </td>
  </ng-container>
  <ng-container matColumnDef="description">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'core.description' | translate | uppercase }}
    </th>
    <td mat-cell *matCellDef="let caseType" class="description-cell">
      {{ caseType.description }}
    </td>
  </ng-container>
  <ng-container matColumnDef="workspaces">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'title.workspaces' | translate | uppercase }}
    </th>
    <td mat-cell *matCellDef="let caseType">
      <ts-loading-attribute
        icon="ri-file-copy-2-line"
        [value]="caseType.usedByWorkspaces"
        class="flex-row align-items-center justify-left"
      ></ts-loading-attribute>
    </td>
  </ng-container>
  <ng-container matColumnDef="cases">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'title.cases' | translate | uppercase }}
    </th>
    <td mat-cell *matCellDef="let caseType">
      <ts-loading-attribute
        icon="ri-briefcase-4-line"
        [value]="caseType.usedByCases"
        class="flex-row align-items-center justify-left"
      ></ts-loading-attribute>
    </td>
  </ng-container>
  <ng-container matColumnDef="edit">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let caseType" class="icon-cell">
      <button
        class="icon-button"
        type="button"
        (click)="editClicked.emit(caseType); $event.stopPropagation()"
        data-cy="case-type-edit"
      >
        <i class="ri-pencil-line"></i>
      </button>
    </td>
  </ng-container>

  <ng-container matColumnDef="delete">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let caseType" class="icon-cell">
      <button
        class="icon-button danger"
        type="button"
        (click)="deleteClicked.emit(caseType); $event.stopPropagation()"
        data-cy="case-type-delete"
      >
        <i class="ri-delete-bin-6-line"></i>
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="visibleColumns"></tr>
  <tr mat-row *matRowDef="let caseType; columns: visibleColumns"></tr>
  </table>
</div>
